import {
  textToBold, textToItalics, toLowerCase, noBreak, hBox, customshortcuts, toTextCase, enlargethispage, hbox,
  allowdisplaybreaks,
  clearpage,
  pagebreak,
  Query,
  AQ,
  hspace,
  vspace,
  midrule,
  cmidrule,
  chaptermark,
  setcounter,
  setconter,
  pagestyle,
  thispagestyle
} from "../Utils/shortcutBindings"

export const aceShortcuts = (ace, props, handleSave) => {

  ace.current.editor.container.addEventListener("keydown", (e) => {
    const isSave = (e.ctrlKey || e.metaKey) && e.key === "s";
    if (isSave) {
      e.preventDefault();
      e.stopPropagation();
      if (handleSave) handleSave();
      return;
    }
    const isWindowsAlt8 = e.altKey && !e.ctrlKey && !e.shiftKey && e.key === "8";
    const isMacOption8 = e.metaKey && e.altKey && !e.ctrlKey && !e.shiftKey && e.key === "8";
    if (isWindowsAlt8 || isMacOption8) {
      e.preventDefault();
      noBreak(ace);
    }
  });
  ace.current.editor.commands.addCommand({
    name: "SaveTex",
    bindKey: {
      win: "Ctrl-S",
      mac: "Command-s",
    },
    exec: () => handleSave(),
    readOnly: true,
  });

  // console.log(props);
  ace.current.editor.commands.addCommand({
    name: "TextBold",
    bindKey: {
      win: "Ctrl-B",
      mac: "Command-B",
    },
    exec: () => textToBold(ace),
    readOnly: true,
  });
  ace.current.editor.commands.addCommand({
    name: "enlargethispage",
    bindKey: {
      win: "Ctrl-M",
      mac: "Command-Q",
    },
    exec: () => enlargethispage(ace),
    readOnly: true,
  });
  ace.current.editor.commands.addCommand({
    name: "hbox",
    bindKey: {
      win: "Ctrl-Alt-h",
      mac: "Command-Q",
    },
    exec: () => hbox(ace),
    readOnly: true,
  });
  //no key
  ace.current.editor.commands.addCommand({
    name: "allowdisplaybreaks",
    bindKey: {
      win: "Alt-3",
      mac: "Command-Q",
    },
    exec: () => allowdisplaybreaks(ace),
    readOnly: true,
  });
  ace.current.editor.commands.addCommand({
    name: "clearpage",
    bindKey: {
      win: "Ctrl-Alt-C",
      mac: "Command-Q",
    },
    exec: () => clearpage(ace),
    readOnly: true,
  });
  ace.current.editor.commands.addCommand({
    name: "pagebreak",
    bindKey: {
      win: "Alt-7",
      mac: "Command-Q",
    },
    exec: () => pagebreak(ace),
    readOnly: true,
  });
  //no key
  ace.current.editor.commands.addCommand({
    name: "Query",
    bindKey: {
      win: "Alt-4",
      mac: "Command-Q",
    },
    exec: () => Query(ace),
    readOnly: true,
  });
  //no key
  ace.current.editor.commands.addCommand({
    name: "AQ",
    bindKey: {
      win: "Alt-9",
      mac: "Command-Q",
    },
    exec: () => AQ(ace),
    readOnly: true,
  });
  ace.current.editor.commands.addCommand({
    name: "hspace",
    bindKey: {
      win: "Alt-1",
      mac: "Command-Q",
    },
    exec: () => hspace(ace),
    readOnly: true,
  });
  ace.current.editor.commands.addCommand({
    name: "vspace",
    bindKey: {
      win: "Alt-2",
      mac: "Command-Q",
    },
    exec: () => vspace(ace),
    readOnly: true,
  });
  ace.current.editor.commands.addCommand({
    name: "midrule",
    bindKey: {
      win: "Alt-6",
      mac: "Command-Q",
    },
    exec: () => midrule(ace),
    readOnly: true,
  });
  ace.current.editor.commands.addCommand({
    name: "cmidrule",
    bindKey: {
      win: "Alt-5",
      mac: "Command-Q",
    },
    exec: () => cmidrule(ace),
    readOnly: true,
  });
  //no key
  ace.current.editor.commands.addCommand({
    name: "chaptermark",
    bindKey: {
      win: "Ctrl-7",
      mac: "Command-Q",
    },
    exec: () => chaptermark(ace),
    readOnly: true,
  });
  //nokey
  ace.current.editor.commands.addCommand({
    name: "setcounter",
    bindKey: {
      win: "Ctrl-8",
      mac: "Command-Q",
    },
    exec: () => setcounter(ace),
    readOnly: true,
  });
  //nokey
  ace.current.editor.commands.addCommand({
    name: "setconter",
    bindKey: {
      win: "Ctrl-9",
      mac: "Command-Q",
    },
    exec: () => setconter(ace),
    readOnly: true,
  });
  //nokey
  ace.current.editor.commands.addCommand({
    name: "pagestyle",
    bindKey: {
      win: "Ctrl-Alt-1",
      mac: "Command-Q",
    },
    exec: () => pagestyle(ace),
    readOnly: true,
  });
  //no key
  ace.current.editor.commands.addCommand({
    name: "thispagestyle",
    bindKey: {
      win: "Ctrl-Alt-2",
      mac: "Command-Q",
    },
    exec: () => thispagestyle(ace),
    readOnly: true,
  });









  ace.current.editor.commands.addCommand({
    name: "TextItalic",
    bindKey: {
      win: "Ctrl-I",
      mac: "Command-I",
    },
    exec: () => textToItalics(ace),
    readOnly: true,
  });
  ace.current.editor.commands.addCommand({
    name: "lowercase",
    bindKey: {
      win: "Alt-L",
      mac: "Alt-L",
    },
    exec: () => toLowerCase(ace),
    readOnly: true,
  });
  ace.current.editor.commands.addCommand({
    name: "Textcase",
    bindKey: {
      win: "Alt-Shift-X",
      mac: "Alt-Shift-X",
    },
    exec: () => toTextCase(ace),
    readOnly: true,
  });
  ace.current.editor.commands.addCommand({
    name: "nobreak",
    bindKey: {
      win: "Alt-B",
      mac: "Command-Option-B",
    },
    exec: () => noBreak(ace),
    readOnly: true,
  });
  ace.current.editor.commands.addCommand({
    name: "hBox",
    bindKey: {
      win: "Ctrl-Shift-H",
      mac: "Command-Shift-H",
    },
    exec: () => hBox(ace),
    readOnly: true,
  });

  ace.current.editor.commands.addCommand({
    name: "Latex Compile",
    bindKey: {
      win: "Ctrl-.",
      mac: "Command-.",
    },
    exec: props.compileTrigger,
    readOnly: true,
  });

  ace.current.editor.commands.addCommand({
    name: "Track Latex Compile",
    bindKey: {
      win: "Ctrl-F6",
      mac: "Command-F6",
    },
    exec: () => {
      console.log("Shortcut fired");
      props.compileTrackTrigger();
    },
    readOnly: true,
  });

  ace.current.editor.commands.addCommand({
    name: "Full pdf",
    bindKey: {
      win: "Alt-F11",
      mac: "Option-F11",
    },
    exec: props.toggleEditor,
    readOnly: true,
  });

  ace.current.editor.commands.addCommand({
    name: "Insert Math",
    bindKey: {
      win: "Ctrl-Q",
      mac: "Command-Q",
    },
    exec: () => {
      const btn = document.getElementById("insertMathBtn");
      if (btn) btn.click();
    },
    readOnly: true,
  });
  //MARK:PdfViewer
  ace.current.editor.commands.addCommand({
    name: "Zoom Out",
    bindKey: {
      win: "Alt--",
      mac: "Command--",
    },
    exec: () => {
      const btn = document.getElementById("zoomout");
      if (btn) btn.click();
    },
    readOnly: true,
  });

  ace.current.editor.commands.addCommand({
    name: "Insert Math",
    bindKey: {
      win: "Ctrl-Q",
      mac: "Command-Q",
    },
    exec: () => {
      const btn = document.getElementById("insertMathBtn");
      if (btn) btn.click();
    },
    readOnly: true,
  });
  //new file in Short AceFunctional
  //     win: "Ctrl-F2",
  //     mac: "Command-F2",

  ace.current.editor.commands.addCommand({
    name: "Replace",
    bindKey: {
      win: "Ctrl-R",
      mac: "Command-R",
    },
    exec: () => {
      const btn = document.getElementById("replace");
      if (btn) btn.click();
    },
    readOnly: true,
  });



  // const test = (a, b) => {
  //   console.log(a, b);
  // };
  // ace.current.editor.commands.addCommand({
  //   name: "shortcuts",
  //   bindKey: {
  //     win: "Ctrl-1|Ctrl-2",
  //   },
  //   exec: test,
  //   readOnly: true,
  // });

  //  ace.current.editor.commands.addCommand({
  //           name: "",
  //           bindKey: {
  //             win: "Ctrl-N",
  //             mac: "Command-N",
  //           },
  //           exec: props.compileTrack,
  //           readOnly: true,
  //         });


  ace.current.editor.commands.addCommand({
    name: "looseness-1",
    bindKey: {
      win: "Ctrl-1",
      mac: "Ctrl-1",
    },
    exec: () => customshortcuts(1, ace),
    readOnly: true,
  });
  ace.current.editor.commands.addCommand({
    name: "vfill\\eject",
    bindKey: {
      win: "Ctrl-2",
      mac: "Ctrl-2",
    },
    exec: () => customshortcuts(2, ace),
    readOnly: true,
  });
  ace.current.editor.commands.addCommand({
    name: "unskip\\break",
    bindKey: {
      win: "Ctrl-3",
      mac: "Ctrl-3",
    },
    exec: () => customshortcuts(3, ace),
    readOnly: true,
  });
  ace.current.editor.commands.addCommand({
    name: "custom_shortcut_1",
    bindKey: {
      win: "Ctrl-4",
      mac: "Ctrl-4",
    },
    exec: () => customshortcuts(4, ace),
    readOnly: true,
  });
  ace.current.editor.commands.addCommand({
    name: "custom_shortcuts_2",
    bindKey: {
      win: "Ctrl-5",
      mac: "Ctrl-5",
    },
    exec: () => customshortcuts(5, ace),
    readOnly: true,
  });
  ace.current.editor.commands.addCommand({
    name: "custom_shortcuts_3",
    bindKey: {
      win: "Ctrl-6",
      mac: "Ctrl-6",
    },
    exec: () => customshortcuts(6, ace),
    readOnly: true,
  });

  // ace.current.editor.commands.addCommand({
  //   name: "New File",
  //   bindKey: {
  //     win: "Ctrl-N",
  //     mac: "Command-N",
  //   },
  //   exec: () => customshortcuts(6, ace),
  //   readOnly: true,
  // });

  const latexShortcuts = [
    { key: "Ctrl-Shift-Z", snippet: "\\emph{}", description: "Emphasis" },
    { key: "Ctrl-Shift-S", snippet: "\\textsl{}", description: "Slanted" },
    { key: "Ctrl-Shift-T", snippet: "\\texttt{}", description: "Typewriter" },
    { key: "Ctrl-Shift-C", snippet: "\\textsc{}", description: "Small caps" },
    { key: "Ctrl-Shift-A", snippet: "\\textsff{}", description: "Sans Serif" },
    { key: "Ctrl-Return", snippet: "\\\\", description: "New line" },
    { key: "Ctrl-Shift-M", snippet: "$…$", description: "Inline math mode" },
    { key: "Alt-Shift-M", snippet: "\\[…\\]", description: "Display math mode" },
    { key: "Ctrl-Shift-D", snippet: "_{}", description: "Subscript" },
    { key: "Ctrl-Shift-U", snippet: "^{}", description: "Superscript" },
    { key: "Ctrl-Shift-F", snippet: "\\frac{}{}", description: "Fraction" },
    { key: "Ctrl-Shift-Q", snippet: "\\dfrac{}{}", description: "Display fraction" },
    { key: "Ctrl-Shift-L", snippet: "\\sqrt{}", description: "Square root" },
    { key: "Ctrl-Shift-R", snippet: "\\left … \\right …", description: "Left-Right" },
    { key: "Ctrl-Shift-E", snippet: "\\begin{equation}\n\n\\end{equation}", description: "Equation environment" },
    { key: "Ctrl-Shift-B", snippet: "\\begin{figure}\n\\centering\n\\includegraphics{}\n\\caption{}\n\\end{figure}", description: "Add Figure" },
    { key: "Ctrl-Shift-G", snippet: "\\begin{table}\n\\caption{}\n\\begin{tabular}{lc}\n\\end{tabular}\n\\end{table}", description: "Add Table" },
  ];

  latexShortcuts.forEach(({ key, snippet }) => {
    ace.current.editor.commands.addCommand({
      name: `insert-${snippet}`,
      bindKey: { win: key, mac: key },
      exec: () => {
        ace.current.editor.insert(snippet);
      },
      readOnly: false
    });
  });

}